export const UPLOAD_EXCLUDE_ISINS = 'UPLOAD/FILE';
export const UPLOAD_LOADING = 'UPLOAD/LOADING';
export const UPLOAD_FILESETTINGS = 'UPLOAD/UPLOADFILE';
export const UPLOAD_SHOWCONTENTMANAGER = 'UPLOAD/SHOWCONTENTMANAGER';
